import { createAction, props } from '@ngrx/store';
import { ItemsPagination } from 'src/app/model/api/data-rest';
import { PaginationParams } from 'src/app/model/api/pagination-params';
import { ExportInfo, ImportInfo } from 'src/app/model/export';
import { FileType } from 'src/app/model/file-type';
import { FinalUsersList } from 'src/app/model/final-users-list';
import { UserFile } from 'src/app/model/user-file';


export const getUserFileTypes = createAction('GET_USER_FILE_TYPES');
export const getUserFileTypesSuccess = createAction('GET_USER_FILE_TYPES_SUCCESS', props<{ fileTypes: FileType[]; message: string }>());
export const getUserFileTypesFailed = createAction('GET_USER_FILE_TYPES_FAILED', props<{ errorMessage: string }>());

export const getUserFiles = createAction('GET_USER_FILES', props<{
    typeId?: number; userId?: number; siteId?: number; noPagination: boolean; paging?: PaginationParams;
}>());
export const getUserFilesSuccess = createAction('GET_USER_FILES_SUCCESS', props<{ userFiles: UserFile[]; paging: ItemsPagination }>());
export const getUserFilesFailed = createAction('GET_USER_FILES_FAILED', props<{ errorMessage: string }>());

export const getSiteImages = createAction('GET_SITE_IMAGES');
export const getSiteImagesSuccess = createAction('GET_SITE_IMAGES_SUCCESS', props<{ siteImages: UserFile[] }>());
export const getSiteImagesFailed = createAction('GET_SITE_IMAGES_FAILED', props<{ errorMessage: string }>());

export const getUserFileContent = createAction('GET_USER_FILE_CONTENT', props<{ userFile: UserFile; userId?: number }>());
export const getUserFileContentSuccess = createAction('GET_USER_FILE_CONTENT_SUCCESS', props<{
    userFile: UserFile; fileContent: string;
}>());
export const getUserFileContentFailed = createAction('GET_USER_FILE_CONTENT_FAILED', props<{ errorMessage: string }>());
export const clearFileContent = createAction('CLEAR_FILE_CONTENT', props<{ userFile: UserFile }>());

export const addUserFile = createAction('ADD_USER_FILE', props<{ userFile: UserFile; userId?: number }>());
export const addUserFileSuccess = createAction('ADD_USER_FILE_SUCCESS', props<{ userFile: UserFile; userId?: number; message: string }>());
export const addUserFileFailed = createAction('ADD_USER_FILE_FAILED', props<{ errorMessage: string }>());
export const noFileToLoad = createAction('NO_FILE_TO_LOAD');

export const deleteUserFile = createAction('DELETE_USER_FILE', props<{ userFile: UserFile; userId?: number }>());
export const deleteUserFileSuccess = createAction('DELETE_USER_FILE_SUCCESS', props<{ userFile: UserFile; message: string }>());
export const deleteUserFileFailed = createAction('DELETE_USER_FILE_FAILED', props<{ errorMessage: string }>());

// FINAL USERS
export const resetFinalUsersListDialog = createAction('RESET_FINALUSERS_LIST_DIALOG');
export const exportFinalUsersList = createAction('EXPORT_FINALUSERS_LIST', props<{ name: string, userId?: number }>());
export const exportFinalUsersListSuccess = createAction('EXPORT_FINALUSERS_LIST_SUCCESS', props<{ message: string }>());
export const exportFinalUsersListFailed = createAction('EXPORT_FINALUSERS_LIST_FAILED', props<{ errorMessage: string }>());

export const getFinalUsersLists = createAction('GET_FINALUSERS_LISTS', props<{ paging?: PaginationParams, userId?: number }>());
export const getFinalUsersListsSuccess = createAction('GET_FINALUSERS_LISTS_SUCCESS', props<{
    finalUsersLists: FinalUsersList[]; paging: ItemsPagination;
}>());
export const getFinalUsersListsFailed = createAction('GET_FINALUSERS_LISTS_FAILED', props<{ errorMessage: string }>());

export const editFinalUsersList = createAction('EDIT_FINALUSERS_LIST', props<{ list?: FinalUsersList, name: string, userId?: number }>());
export const editFinalUsersListSuccess = createAction('EDIT_FINALUSERS_LIST_SUCCESS', props<{ list?: FinalUsersList, message: string }>());
export const editFinalUsersListFailed = createAction('EDIT_FINALUSERS_LIST_FAILED', props<{ errorMessage: string }>());

export const deleteFinalUsersList = createAction('DELETE_FINALUSERS_LIST', props<{ exportList?: FinalUsersList, userId?: number }>());
export const deleteFinalUsersListSuccess = createAction('DELETE_FINALUSERS_LIST_SUCCESS', props<{
    finalUsersLists: FinalUsersList; message: string;
}>());
export const deleteFinalUsersListFailed = createAction('DELETE_FINALUSERS_LIST_FAILED', props<{ errorMessage: string }>());

export const importFinalUsersList = createAction('IMPORT_FINALUSERS_LIST', props<{ importList?: FinalUsersList, userId?: number }>());
export const importFinalUsersListSuccess = createAction('IMPORT_FINALUSERS_LIST_SUCCESS', props<{ message: string }>());
export const importFinalUsersListFailed = createAction('IMPORT_FINALUSERS_LIST_FAILED', props<{ errorMessage: string }>());

export const resetFinalUsersList = createAction('RESET_FINALUSERS_LIST');
export const deleteFinalUsers = createAction('DELETE_FINALUSERS', props<{ userId?: number }>());
export const deleteFinalUsersSuccess = createAction('DELETE_FINALUSERS_SUCCESS', props<{ message: string }>());
export const deleteFinalUsersFailed = createAction('DELETE_FINALUSERS_FAILED', props<{ errorMessage: string }>());



//----------------------------EXPORT DEVICE
//-GET LIST
export const getExportDeviceList = createAction('GET_EXPORT_DEVICE_LISTS', props<{ isImpersMode: boolean; paging?: PaginationParams }>());
export const getExportDeviceListSuccess = createAction('GET_EXPORT_DEVICE_LISTS_SUCCESS', props<{
    exportLists: ExportInfo[]; paging: ItemsPagination;
}>());
export const getExportDeviceListFailed = createAction('GET_EXPORT_DEVICE_LISTS_FAILED', props<{ errorMessage: string }>());


//-CREATE
export const resetExportDeviceDialog = createAction('RESET_EXPORT_DEVICE_DIALOG');

export const exportDevice = createAction('EXPORT_DEVICE', props<{ exportInfo: ExportInfo }>());
export const exportDeviceSuccess = createAction('EXPORT_DEVICE_SUCCESS', props<{ message: string }>());
export const exportDeviceFailed = createAction('EXPORT_DEVICE_FAILED', props<{ errorMessage: string }>());


//-EDIT
export const updateExportDevice = createAction('UPDATE_EXPORT_DEVICE', props<{ exportId: number, exportInfo: ExportInfo }>());
export const updateExportDeviceSuccess = createAction('UPDATE_EXPORT_DEVICE_SUCCESS', props<{
    message: string;
}>());
export const updateExportDeviceFailed = createAction('UPDATE_EXPORT_DEVICE_FAILED', props<{ errorMessage: string }>());


//-DELETE
export const deleteExportDevice = createAction('DELETE_EXPORT_DEVICE', props<{ exportInfo: ExportInfo; userId?: number }>());
export const deleteExportDeviceSuccess = createAction('DELETE_EXPORT_DEVICE_SUCCESS', props<{
    message: string;
}>());
export const deleteExportDeviceFailed = createAction('DELETE_EXPORT_DEVICE_FAILED', props<{ errorMessage: string }>());

//-IMPORT
export const resetImportDeviceDialog = createAction('RESET_IMPORT_DEVICE_DIALOG');

export const importDevice = createAction('IMPORT_DEVICE', props<{ exportId: number, importInfo: ImportInfo }>());
export const importDeviceSuccess = createAction('IMPORT_DEVICE_SUCCESS', props<{ message: string }>());
export const importDeviceFailed = createAction('IMPORT_DEVICE_FAILED', props<{ errorMessage: string }>());


//-----EXPORT DEVICE


//----------------------------EXPORT DEVICE MTMA
//-GET LIST
export const getMtmaExportDeviceList = createAction('GET_MTMA_EXPORT_DEVICE_LISTS', props<{ isImpersMode: boolean; paging?: PaginationParams }>());
export const getMtmaExportDeviceListSuccess = createAction('GET_MTMA_EXPORT_DEVICE_LISTS_SUCCESS', props<{
    exportLists: ExportInfo[]; paging: ItemsPagination;
}>());
export const getMtmaExportDeviceListFailed = createAction('GET_MTMA_EXPORT_DEVICE_LISTS_FAILED', props<{ errorMessage: string }>());


//-CREATE
export const resetMtmaExportDeviceDialog = createAction('RESET_MTMA_EXPORT_DEVICE_DIALOG');

export const exportMtmaDevice = createAction('EXPORT_MTMA_DEVICE', props<{ exportInfo: ExportInfo; isImpersMode: boolean; }>());
export const exportMtmaDeviceSuccess = createAction('EXPORT_MTMA_DEVICE_SUCCESS', props<{ message: string }>());
export const exportMtmaDeviceFailed = createAction('EXPORT_MTMA_DEVICE_FAILED', props<{ errorMessage: string }>());


//-EDIT
export const updateMtmaExportDevice = createAction('UPDATE_MTMA_EXPORT_DEVICE', props<{ exportId: number, exportInfo: ExportInfo; isImpersMode: boolean; }>());
export const updateMtmaExportDeviceSuccess = createAction('UPDATE_MTMA_EXPORT_DEVICE_SUCCESS', props<{
    message: string;
}>());
export const updateMtmaExportDeviceFailed = createAction('UPDATE_MTMA_EXPORT_DEVICE_FAILED', props<{ errorMessage: string }>());


//-DELETE
export const deleteMtmaExportDevice = createAction('DELETE_MTMA_EXPORT_DEVICE', props<{ exportInfo: ExportInfo; isImpersMode: boolean; userId?: number; }>());
export const deleteMtmaExportDeviceSuccess = createAction('DELETE_MTMA_EXPORT_DEVICE_SUCCESS', props<{
    message: string;
}>());
export const deleteMtmaExportDeviceFailed = createAction('DELETE_MTMA_EXPORT_DEVICE_FAILED', props<{ errorMessage: string }>());

//-IMPORT
export const resetMtmaImportDeviceDialog = createAction('RESET_MTMA_IMPORT_DEVICE_DIALOG');

export const importMtmaDevice = createAction('IMPORT_MTMA_DEVICE', props<{ exportId: number, importInfo: ImportInfo; isImpersMode: boolean; }>());
export const importMtmaDeviceSuccess = createAction('IMPORT_MTMA_DEVICE_SUCCESS', props<{ message: string }>());
export const importMtmaDeviceFailed = createAction('IMPORT_MTMA_DEVICE_FAILED', props<{ errorMessage: string }>());


//-----EXPORT DEVICE
